import { NoteItem } from "@/components/Documents/NoteItem.tsx";
import AddNoteDialog from "@/components/Forms/AddNoteDialog.tsx";
import DownloadAllNotesButton from "@/components/Forms/DownloadAllNotesButton.tsx";
import { type Note, useFetchNotesForCase } from "@/queries/useFetchNotesForCase.ts";
import { Grid2 as Grid, List, ListItem, Paper, Stack, TextField, Typography } from "@mui/material";
import React, { type ChangeEvent } from "react";

type Props = {
    caseIdUUID: string;
    limitToCategory?: string;
};

const NoteList = ({ caseIdUUID, limitToCategory }: Props) => {
    const [searchValue, setSearchValue] = React.useState("");
    const { data, error, isError, isLoading } = useFetchNotesForCase({
        caseIdUUID,
    });

    let displayNotes: Note[] = [];

    if (data !== undefined && data !== null) {
        displayNotes = data;

        if (limitToCategory) {
            displayNotes = displayNotes.filter((note) => {
                return note.tag?.toLowerCase().includes(limitToCategory.toLowerCase());
            });
        }

        if (searchValue) {
            displayNotes = displayNotes.filter((note) => {
                return (
                    note.note?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    note.noteBy?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    note.tag?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    note.metaModifiedWhen
                        ?.toString()
                        .toLowerCase()
                        .includes(searchValue.toLowerCase())
                );
            });
        }
    }

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (isError) {
        return <div>{error.message}</div>;
    }

    return (
        <Grid container>
            <Grid size={12}>
                <Paper
                    sx={{
                        mb: 2,
                        mx: 1,
                    }}
                >
                    <Grid
                        container
                        sx={{
                            borderRadius: "8px",
                            p: 1,
                        }}
                    >
                        <Grid
                            size={12}
                            sx={{
                                p: 1,
                                mb: 1,
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <Typography variant={"h5"}>Notes</Typography>
                            <Stack
                                sx={{
                                    flexDirection: "row",
                                    justifyContent: "flex-end",
                                }}
                            >
                                <DownloadAllNotesButton
                                    caseUUID={caseIdUUID}
                                    disableDownload={data && data?.length <= 0}
                                />
                                <AddNoteDialog caseUUID={caseIdUUID} />
                            </Stack>
                        </Grid>
                        <Grid size={12} sx={{ p: 1, mb: 1 }}>
                            <TextField
                                value={searchValue}
                                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                    setSearchValue(event.target.value);
                                }}
                                placeholder={"Search Notes"}
                                sx={{
                                    width: "100%",
                                }}
                                size={"small"}
                            />
                        </Grid>
                        <Grid size={12} sx={{ p: 1 }}>
                            <List>
                                {displayNotes.map((note: Note) => (
                                    <ListItem key={note.idUUID}>
                                        <NoteItem note={note} caseIdUUID={caseIdUUID} />
                                    </ListItem>
                                ))}
                            </List>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default NoteList;
